import danger from "./danger";

export default { danger, }